export enum ImageWrapperAppearances {
    Splash = "splash",
    Headshot = "headshot"
}